import { IYearMonth } from '@/coreDomainsModule/date';

/**
 * 出力形式の定数
 */
export const OutputFormat = {
  BY_MONTH: 'byMonth',
  BY_DATA_TYPE: 'byDataType',
} as const;

/**
 * 出力形式の型
 */
export type OutputFormat = (typeof OutputFormat)[keyof typeof OutputFormat];

/**
 * 選択可能な項目のベースインターフェース
 */
export interface ISelectableItem {
  key: string;
  label: string;
  checked: boolean;
  selectionOrder?: number;
  /** 単一フィールド項目の挿入位置（月別出力データ項目のキー、この項目の前に挿入） */
  insertBeforeKey?: string;
}

/**
 * マスタ項目
 */
export type IMasterItem = ISelectableItem;

/**
 * 出力データ項目
 */
export type IOutputDataItem = ISelectableItem;

/**
 * プレビューヘッダーのタイプ
 */
export const PreviewHeaderType = {
  MASTER: 'master',
  OUTPUT_DATA: 'outputData',
} as const;

/**
 * プレビューヘッダーのタイプ
 */
export type PreviewHeaderType = (typeof PreviewHeaderType)[keyof typeof PreviewHeaderType];

/**
 * プレビューヘッダー
 */
export interface IPreviewHeader {
  id: string;
  label: string;
  type: PreviewHeaderType;
  masterKey?: string;
  outputDataKey?: string;
  yearMonth?: IYearMonth;
  originalIndex: number;
}

/**
 * マスタ項目かどうかを判定する型ガード
 * @param header - プレビューヘッダー
 * @returns マスタ項目の場合true
 */
export const isMasterHeader = (header: IPreviewHeader): boolean => {
  return header.type === PreviewHeaderType.MASTER && header.masterKey !== undefined;
};

/**
 * 出力データ項目かどうかを判定する型ガード
 * @param header - プレビューヘッダー
 * @returns 出力データ項目の場合true
 */
export const isOutputDataHeader = (header: IPreviewHeader): boolean => {
  return header.type === PreviewHeaderType.OUTPUT_DATA && header.outputDataKey !== undefined;
};

/**
 * Excelエクスポート結果データ
 */
export interface IExportInventoryResultData {
  /** S3からのダウンロード用署名付きURL */
  download_url: string;
  /** ダウンロード用ファイル名 */
  file_name: string;
  /** URLの有効期限（ISO8601形式） */
  expires_at: string;
}
